"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUrls;

var _tempAuthTokenHandler = _interopRequireDefault(require("@shootsta/temp-auth-token-handler"));

var _joinSeparator = _interopRequireDefault(require("./constants/joinSeparator"));

var _utils = require("./utils");

var _getSignedUrls = _interopRequireWildcard(require("./queries/getSignedUrls"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module replaceBucketKeysWithUrls */

/* Retrieving URLs from the network */
async function getS3Urls({
  apiClient,
  urlsConfig,
  organisationId
}) {
  // Call api using graphql-request apiClient
  if (apiClient.request) {
    const {
      getS3SignedUrls
    } = await apiClient.request(_getSignedUrls.getSignedUrlsQuery, {
      urlsConfig,
      organisationId
    });
    return getS3SignedUrls;
  } // Call api using apollo-client apiClient


  const {
    data,
    errors
  } = await apiClient.query({
    variables: {
      urlsConfig,
      organisationId
    },
    query: _getSignedUrls.default,
    context: {
      module: 'assets'
    },
    fetchPolicy: 'no-cache'
  });

  if (errors && errors.length) {
    console.error(errors[0].message);
    return urlsConfig.map(() => void 0);
  }

  return data.getS3SignedUrls;
}
/* Build data object hierarchy */


function getValueFromDataWithPathKeys(data, keysArray) {
  if (keysArray.length === 1) {
    return {
      bucketKey: data[keysArray[0]],
      action: 'get'
    };
  }

  return getValueFromDataWithPathKeys(data[keysArray[0]], keysArray.slice(1, keysArray.length));
}
/* Pulling out S3 bucket keys using the data object hierarchy */


function getS3KeyFromPath(path, data) {
  const keys = path.split(_joinSeparator.default);
  return getValueFromDataWithPathKeys(data, keys);
}

function getS3KeysFromPathStructure(data, paths) {
  return paths.map(path => getS3KeyFromPath(path, data));
}
/* Adding the new URLs into the original data object */


function updateDataSubsetWithS3Url(data, path, url) {
  const keys = path.split(_joinSeparator.default);
  const lastKey = keys[keys.length - 1];
  const bottomNestedObject = keys.reduce((currentNestedObject, key) => key === lastKey ? currentNestedObject : currentNestedObject[key], data);
  bottomNestedObject[lastKey] = url;
  return data;
}

function populateDataWithS3Urls(data, paths, urls) {
  return paths.reduce((newData, path, index) => updateDataSubsetWithS3Url(newData, path, urls[index]), // We use this to deep clone the object so we can change nested values
  JSON.parse(JSON.stringify(data)));
}
/**
 * Takes a data object and swaps out any defined key/bucketKey values with pre-signed urls.
 * Supports nested objects/keys.
 *
 * eg. { foo: '/foo/foobar.jpg' }, ['foo'] => { foo: 'aws.com/.../foo/foobar.jpg' }
 *
 * eg. { foo: { bar: '/foo/foobar.jpg' } }, [{ key: 'foo', subKeys: ['bar'] }] =>
 *        { foo: { bar: 'aws.com/.../foo/foobar.jpg' } }
 *
 * @param {*} apiClient
 * @param {Object} data
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @param {string} organisationId
 * @param {string} tempAuthToken
 * @return {Promise<*>}
 */


async function replaceBucketKeysWithUrls({
  apiClient,
  data,
  substitutedKeys,
  organisationId,
  ignorePattern,
  tempAuthToken
}) {
  if (!apiClient) {
    throw new Error('Must provide an apollo API client');
  }

  const selectedOrganisationId = organisationId || data.organisationId;
  const dataHierarchyStructure = (0, _utils.getPathsFromData)(data, substitutedKeys, ignorePattern);
  const urlsConfig = getS3KeysFromPathStructure(data, dataHierarchyStructure);

  if (!urlsConfig.length) {
    return data;
  }

  const tempAuthTokenHandler = new _tempAuthTokenHandler.default();
  tempAuthTokenHandler.attemptToOverrideToken(tempAuthToken);
  const urls = await getS3Urls({
    apiClient,
    urlsConfig,
    organisationId: selectedOrganisationId
  });
  tempAuthTokenHandler.attemptToResetToken();
  return populateDataWithS3Urls(data, dataHierarchyStructure, urls);
}